export default "__VITE_ASSET__1e2567c5__"